'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';

interface DescriptionItem {
  title: string;
  value: string;
}

interface WimbledonAroundDataProps {
  type: 'walk' | 'train';
  tabDescription: DescriptionItem[];
}
export default function WimbledonAroundData(props: WimbledonAroundDataProps) {
  const { type, tabDescription } = props;
  const tabTypeClass = type && cn[type] ? cn[type] : '';

  return (
    <Stack className={cn.WimbledonAroundData}>
      <Box className={cn.wimbledonBridgeDataInner}>
        <Box component="article" className={cn.wimbledonBridgeDataBlock}>
          {tabDescription.map((item, index) => (
            <Box key={index} className={cn.descriptionItem}>
              <Box key={index} className={cn.descriptionItem__title}>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                  className={cn.descriptionTitle}
                >
                  {ReactHtmlParser(item.title)}
                </ParallaxText>
              </Box>
              <Box key={index} className={cn.descriptionItem__value}>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                  className={cn.descriptionValue}
                >
                  {ReactHtmlParser(item.value)}
                </ParallaxText>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Stack>
  );
}
